export default __webpack_public_path__ + "static/media/SWT1370.34I-34996_-24487_0.4ccac74d.jpg";